import { Component, OnInit } from '@angular/core';
import {constants} from '../../constant/constant';
import {FormBuilder, Validators} from '@angular/forms';
import {UserService} from '../../service/user.service';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';
import Swal from "sweetalert2";

@Component({
  selector: 'app-ticket-booking',
  templateUrl: './ticket-booking.component.html',
  styleUrls: ['./ticket-booking.component.css']
})
export class TicketBookingComponent implements OnInit {
  checkin: any;
  checkout: any;
  package: any;
  bookForm: any;
  country = constants.country;
  constructor(private formBuilder: FormBuilder,private userService:UserService, private datePipe: DatePipe,
              private route :Router,private scrollToService: ScrollToService,) {
    this.package = JSON.parse(localStorage.getItem('package'));

    this.bookForm = this.formBuilder.group({
      days: ['',Validators.required],
      name: ['', Validators.required],
      start: ['', Validators.required],
      end: ['', Validators.required],
      pax: ['', Validators.required],
      children: ['', Validators.required],
      infants: ['', Validators.required],
      adults: ['', Validators.required],
      email: ['', Validators.required],
      mobile: ['', Validators.required],
      cont: ['', Validators.required],
      package: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.bookForm.controls['package'].setValue(this.package.title);
    this.bookForm.controls['days'].setValue(this.package.destination.country +' - ' +this.package.origin.country);
    this.triggerScrollTo();
  }

  saveBooking(){
    let  req={
      id:0,
      customerDTO:{
        clientEmail: this.bookForm.controls.email.value,
        clientName:this.bookForm.controls.name.value,
        country: this.bookForm.controls.cont.value,
        mobileNumber: this.bookForm.controls.mobile.value,
      },
      adults:this.bookForm.controls.adults.value,
      children:this.bookForm.controls.children.value,
      infants:this.bookForm.controls.infants.value,
      destination:this.package.destination.id,
      airTicket: this.package.id,
      isTailorMade:0,
      origin:this.package.origin.id,
    }
    this.userService.ticketbookingSave(req).subscribe(
        res => {
          if (res.responseCode == 200) {
            Swal.fire(
                'Booking Success!',
                'session booked successfully',
                'success'
            )
            this.route.navigate(['/index-packages']);
          } else {
            Swal.fire(
                'Booking Faild !',
                'somthing went wrong please try again',
                'error'
            )
          }
        }
    )
  }

  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }
}
